var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-color-picker"},[_c('pendo-color-picker',{attrs:{"labels":{ top: 'Assigned Color' },"value-key":"hex","presets":_vm.swatchColors},model:{value:(_vm.selectedColor),callback:function ($$v) {_vm.selectedColor=$$v},expression:"selectedColor"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }